import { Category } from './category.model';
import { Media } from './media.model';

export enum LearningType {
  Article = 'article',
  Book = 'book',
  Building = 'building',
  Experience = 'experience',
  FaceBookGroup = 'facebook-group',
  Influencer = 'influencer',
  InstagramChannel = 'instagram-channel',
  WebsiteOrApp = 'website-or-app',
  Movie = 'movie',
  Podcast = 'podcast',
  TEDTalk = 'ted-talk',
  Visual = 'visual',
  Video = 'video',
  Other = 'other',
}

export interface LearningItem {
  id: number;
  creationDate?: Date;
  updatedDate?: Date;
  author: string;
  type: LearningType;
  url: string;
  duration: string;
  categories: Category[];
  mainCategory?: Category;
  title: string;
  recommendation: string;
  description: string;
  recommended: boolean;
  published: boolean;
  languages: string[];
  media: Media[];
}

export const titleRules = [
  (value: string) => {
    if (value) return true;

    return 'Name is required.';
  },
];

export const descriptionRules = [
  (value: string) => {
    if (value) return true;

    return 'Description is required.';
  },
];

export const recommendationRules = [
  (value: string) => {
    if (value) return true;

    return 'Recommendation is required.';
  },
];

export const learningTypes = [
  {
    title: 'Article',
    value: LearningType.Article,
  },
  {
    title: 'Book',
    value: LearningType.Book,
  },
  {
    title: 'Building',
    value: LearningType.Building,
  },
  {
    title: 'Experience',
    value: LearningType.Experience,
  },
  {
    title: 'Facebook Group',
    value: LearningType.FaceBookGroup,
  },
  {
    title: 'Website or App',
    value: LearningType.WebsiteOrApp,
  },
  {
    title: 'Influencer',
    value: LearningType.Influencer,
  },
  {
    title: 'Instagram Channel',
    value: LearningType.InstagramChannel,
  },
  {
    title: 'Movie',
    value: LearningType.Movie,
  },
  {
    title: 'Podcast',
    value: LearningType.Podcast,
  },
  {
    title: 'TED Talk',
    value: LearningType.TEDTalk,
  },
  {
    title: 'Visual',
    value: LearningType.Visual,
  },
  {
    title: 'Video',
    value: LearningType.Video,
  },
  {
    title: 'Other',
    value: LearningType.Other,
  },
];

export const getLearningType = (t: LearningType): string => {
  return learningTypes.find((v) => v.value === t)?.title || (t as string);
};
